import get from 'lodash/get';

const getValueByDotNotation = (obj, path) => {
  return get(obj, path);
};

export default getValueByDotNotation;
